import { render, staticRenderFns } from "./ReportsDistributorOld.vue?vue&type=template&id=1c85009a&"
import script from "./ReportsDistributorOld.vue?vue&type=script&lang=js&"
export * from "./ReportsDistributorOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports